var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popver',{attrs:{"closeOnClickModal":false},model:{value:(_vm.showPopver),callback:function ($$v) {_vm.showPopver=$$v},expression:"showPopver"}},[_c('div',{staticClass:"slide-verify-wrapper"},[_c('div',{staticClass:"slide-bar",attrs:{"id":"captcha"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }